'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _select = require('linksoft/initializers/select2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namespace = 'react-select2-wrapper';

var Select2 = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(Select2, _React$Component);

    function Select2(props) {
        (0, _classCallCheck3.default)(this, Select2);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Select2.__proto__ || (0, _getPrototypeOf2.default)(Select2)).call(this, props));

        _this.select = null;
        return _this;
    }

    (0, _createClass3.default)(Select2, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.select = $(_reactDom2.default.findDOMNode(this));
            (0, _select.initSelect2)(this.select);

            this.select.on('change.' + namespace, this.handleSelectionChange.bind(this));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.destroySelect2();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.select.val(newProps.value);
            this.select.trigger('change');
        }
    }, {
        key: 'destroySelect2',
        value: function destroySelect2() {
            this.select.off('change.' + namespace);

            this.select.select2('destroy');
            this.select = null;
        }
    }, {
        key: 'handleSelectionChange',
        value: function handleSelectionChange(e) {
            // const {multiple, value, values} = this.props;
            // const newValue = Array.from( e.target.selectedOptions ).map(opt => opt.value);

            if ((this.props.value || '') + '' !== e.target.value) {
                this.props.onChange(e);
            }
            // if (newValue !== this.state.selectedValue) {
            //     this.setState({selectedValue: newValue});
            //     this.props.onChange(e);
            // }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                multiple = _props.multiple,
                additionalClass = _props.additionalClass,
                placeholder = _props.placeholder,
                disabled = _props.disabled,
                allowClear = _props.allowClear,
                options = _props.options,
                odata = _props.odata,
                ajaxUrl = _props.ajaxUrl,
                orderBy = _props.orderBy,
                odataFilter = _props.odataFilter,
                dataOptions = _props.dataOptions,
                onChange = _props.onChange,
                value = _props.value,
                values = _props.values;

            return _react2.default.createElement(
                'select',
                { className: className + ' ' + additionalClass,
                    multiple: multiple,
                    'data-placeholder': placeholder,
                    'data-odata': odata,
                    disabled: disabled,
                    'data-ajax--url': ajaxUrl,
                    'data-order-by': orderBy,
                    'data-odata-filter': odataFilter,
                    'data-options': (0, _stringify2.default)(dataOptions),
                    'data-allow-clear': allowClear,
                    'data-minimum-input-length': '0',
                    'data-maximum-input-length': '20',
                    value: multiple ? values : value,
                    onChange: onChange },
                options.map(function (opt, i) {
                    return _react2.default.createElement(
                        'option',
                        { key: 'option-' + i, value: opt.value || opt.id || '' },
                        opt.label || opt.name || ''
                    );
                })
            );
        }
    }]);
    return Select2;
}(_react2.default.Component), _class.propTypes = {
    onChange: _react2.default.PropTypes.func.isRequired,
    value: _react2.default.PropTypes.any,
    values: _react2.default.PropTypes.array,
    multiple: _react2.default.PropTypes.bool,
    additionalClass: _react2.default.PropTypes.string,
    placeholder: _react2.default.PropTypes.string,
    maximumSelectionLength: _react2.default.PropTypes.number,
    disabled: _react2.default.PropTypes.bool,
    allowClear: _react2.default.PropTypes.bool,
    options: _react2.default.PropTypes.array,
    odata: _react2.default.PropTypes.bool,
    ajaxUrl: _react2.default.PropTypes.string,
    orderBy: _react2.default.PropTypes.string,
    odataFilter: _react2.default.PropTypes.string,
    dataOptions: _react2.default.PropTypes.object
}, _temp);
exports.default = Select2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/components/Select2.js
// module id = 1100
// module chunks = 0